var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "roc'h",
  "block.minecraft.granite": "greunit",
  "block.minecraft.polished_granite": "greunit lufret",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit lufret",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "andezit lufret",
  "block.minecraft.grass_block": "bloc'h geot",
  "block.minecraft.dirt": "douar",
  "block.minecraft.coarse_dirt": "douar losket",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "warped nylium",
  "block.minecraft.cobblestone": "maen",
  "block.minecraft.oak_planks": "plankennoù derv",
  "block.minecraft.spruce_planks": "plankennoù pruñs",
  "block.minecraft.birch_planks": "plankennoù bezv",
  "block.minecraft.jungle_planks": "plankennoù koad janglenn",
  "block.minecraft.acacia_planks": "plankennoù kasia",
  "block.minecraft.dark_oak_planks": "plankennoù derv teñval",
  "block.minecraft.crimson_planks": "crimson planks",
  "block.minecraft.warped_planks": "warped planks",
  "block.minecraft.oak_sapling": "strujenn zerv",
  "block.minecraft.spruce_sapling": "strujenn bruñs",
  "block.minecraft.birch_sapling": "strujenn vezv",
  "block.minecraft.jungle_sapling": "strujenn janglenn",
  "block.minecraft.acacia_sapling": "strujenn gasia",
  "block.minecraft.dark_oak_sapling": "strujenn derv teñval",
  "block.minecraft.bedrock": "roc'h-gwele",
  "block.minecraft.sand": "traezh",
  "block.minecraft.red_sand": "traezh ruz",
  "block.minecraft.gravel": "grouan",
  "block.minecraft.gold_ore": "kailh aour",
  "block.minecraft.iron_ore": "kailh houarn",
  "block.minecraft.coal_ore": "kailh glaou",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "etev derv",
  "block.minecraft.spruce_log": "etev pruñs",
  "block.minecraft.birch_log": "etev bezv",
  "block.minecraft.jungle_log": "etev koad janglenn",
  "block.minecraft.acacia_log": "etev kasia",
  "block.minecraft.dark_oak_log": "etev derv teñval",
  "block.minecraft.crimson_stem": "crimson stem",
  "block.minecraft.warped_stem": "warped stem",
  "block.minecraft.stripped_oak_log": "etev derv dirusket",
  "block.minecraft.stripped_spruce_log": "etev pruñs dirusket",
  "block.minecraft.stripped_birch_log": "etev bezv dirusket",
  "block.minecraft.stripped_jungle_log": "etev koad janglenn dirusket",
  "block.minecraft.stripped_acacia_log": "etev kasia dirusket",
  "block.minecraft.stripped_dark_oak_log": "etev derv teñval dirusket",
  "block.minecraft.stripped_crimson_stem": "stripped crimson stem",
  "block.minecraft.stripped_warped_stem": "stripped warped stem",
  "block.minecraft.stripped_oak_wood": "koad derv dirusket",
  "block.minecraft.stripped_spruce_wood": "koad pruñs dirusket",
  "block.minecraft.stripped_birch_wood": "koad bezv dirusket",
  "block.minecraft.stripped_jungle_wood": "koad janglenn dirusket",
  "block.minecraft.stripped_acacia_wood": "koad kasia dirusket",
  "block.minecraft.stripped_dark_oak_wood": "koad derv teñval dirusket",
  "block.minecraft.stripped_crimson_hyphae": "stripped crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "hifennoù roudennek ha disleberet",
  "block.minecraft.oak_wood": "koad derv",
  "block.minecraft.spruce_wood": "koad pruñs",
  "block.minecraft.birch_wood": "koad bezv",
  "block.minecraft.jungle_wood": "koad janglenn",
  "block.minecraft.acacia_wood": "koad kasia",
  "block.minecraft.dark_oak_wood": "koad derv teñval",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "warped hyphae",
  "block.minecraft.oak_leaves": "delioù derv",
  "block.minecraft.spruce_leaves": "delioù pruñs",
  "block.minecraft.birch_leaves": "delioù bezv",
  "block.minecraft.jungle_leaves": "delioù janglenn",
  "block.minecraft.acacia_leaves": "delioù kasia",
  "block.minecraft.dark_oak_leaves": "delioù derv teñval",
  "block.minecraft.sponge": "spoue",
  "block.minecraft.wet_sponge": "spoueenn c'hleb",
  "block.minecraft.glass": "gwerenn",
  "block.minecraft.lapis_ore": "kailh lapis lazuli",
  "block.minecraft.lapis_block": "bloc'h lapis-lazuli",
  "block.minecraft.dispenser": "tennerez",
  "block.minecraft.sandstone": "maen-traezh",
  "block.minecraft.chiseled_sandstone": "maen-traezh sizailhet",
  "block.minecraft.cut_sandstone": "maen-traezh sizailhet",
  "block.minecraft.note_block": "bloc'h notenn",
  "block.minecraft.powered_rail": "hent-houarn galloudus",
  "block.minecraft.detector_rail": "hent-houarn dinoer",
  "block.minecraft.sticky_piston": "bountell begus",
  "block.minecraft.cobweb": "gwiad kevnidenn",
  "block.minecraft.grass": "geot",
  "block.minecraft.fern": "raden",
  "block.minecraft.dead_bush": "bochad gwez marv",
  "block.minecraft.seagrass": "geot mor",
  "block.minecraft.sea_pickle": "gwerc'heot",
  "block.minecraft.piston": "bountell",
  "block.minecraft.white_wool": "gloan gwenn",
  "block.minecraft.orange_wool": "gloan orañjez",
  "block.minecraft.magenta_wool": "gloan majenta",
  "block.minecraft.light_blue_wool": "gloan glas-sklaer",
  "block.minecraft.yellow_wool": "glan melen",
  "block.minecraft.lime_wool": "gloan gwer-melen",
  "block.minecraft.pink_wool": "gloan roz",
  "block.minecraft.gray_wool": "gloan griz",
  "block.minecraft.light_gray_wool": "gloan griz sklaer",
  "block.minecraft.cyan_wool": "gloan sian",
  "block.minecraft.purple_wool": "gloan mouk",
  "block.minecraft.blue_wool": "gloan glas",
  "block.minecraft.brown_wool": "gloan gell",
  "block.minecraft.green_wool": "gloan gwer",
  "block.minecraft.red_wool": "gloan ruz",
  "block.minecraft.black_wool": "gloan du",
  "block.minecraft.dandelion": "c'hwervizon",
  "block.minecraft.poppy": "rozenn-moc'h",
  "block.minecraft.blue_orchid": "orkideenn c'hlas",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia",
  "block.minecraft.red_tulip": "tulipezenn ruz",
  "block.minecraft.orange_tulip": "tulipezenn orañjez",
  "block.minecraft.white_tulip": "tulipezenn wenn",
  "block.minecraft.pink_tulip": "tulipezenn roz",
  "block.minecraft.oxeye_daisy": "marc'harid",
  "block.minecraft.cornflower": "glizinenn",
  "block.minecraft.lily_of_the_valley": "louzaouenn-an-hañv",
  "block.minecraft.wither_rose": "rozenn wither",
  "block.minecraft.brown_mushroom": "kabell-touseg gell",
  "block.minecraft.red_mushroom": "kabell-touseg ruz",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "warped fungus",
  "block.minecraft.crimson_roots": "crimson roots",
  "block.minecraft.warped_roots": "warped roots",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping vines",
  "block.minecraft.twisting_vines": "twisting vines",
  "block.minecraft.sugar_cane": "korzenn sukr",
  "block.minecraft.kelp": "bezhin",
  "block.minecraft.bamboo": "bambouz",
  "block.minecraft.gold_block": "bloc'h aour",
  "block.minecraft.iron_block": "bloc'h houarn",
  "block.minecraft.oak_slab": "dar derv",
  "block.minecraft.spruce_slab": "dar pruñs",
  "block.minecraft.birch_slab": "dar bezv",
  "block.minecraft.jungle_slab": "dar koad janglenn",
  "block.minecraft.acacia_slab": "dar kasia",
  "block.minecraft.dark_oak_slab": "dar derv teñval",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "warped slab",
  "block.minecraft.stone_slab": "dar roc'h",
  "block.minecraft.smooth_stone_slab": "dar roc'h plaen",
  "block.minecraft.sandstone_slab": "dar maen-traezh",
  "block.minecraft.cut_sandstone_slab": "troc'hañ an dar maen-traezh",
  "block.minecraft.petrified_oak_slab": "dar derv maenaet",
  "block.minecraft.cobblestone_slab": "dar maen",
  "block.minecraft.brick_slab": "dar brikenn",
  "block.minecraft.stone_brick_slab": "dar brikenn vaen",
  "block.minecraft.nether_brick_slab": "dar brikennoù nether",
  "block.minecraft.quartz_slab": "dar kouarz",
  "block.minecraft.red_sandstone_slab": "dar maen-traezh ruz",
  "block.minecraft.cut_red_sandstone_slab": "troc'hañ an dar maen-traezh ruz",
  "block.minecraft.purpur_slab": "dar purpur",
  "block.minecraft.prismarine_slab": "dar prismarine",
  "block.minecraft.prismarine_brick_slab": "dar brikenn prismarine",
  "block.minecraft.dark_prismarine_slab": "dar prismarine teñval",
  "block.minecraft.smooth_quartz": "smooth quartz block",
  "block.minecraft.smooth_red_sandstone": "maen-traezh ruz lintr",
  "block.minecraft.smooth_sandstone": "maen-traezh lintr",
  "block.minecraft.smooth_stone": "roc'h plaen",
  "block.minecraft.bricks": "brikennoù",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "levraoueg",
  "block.minecraft.mossy_cobblestone": "roc'h man",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "etev-gouloù",
  "block.minecraft.end_rod": "bazh an end",
  "block.minecraft.chorus_plant": "plant korus",
  "block.minecraft.chorus_flower": "bleunienn gorus",
  "block.minecraft.purpur_block": "bloc'h purpur",
  "block.minecraft.purpur_pillar": "peul purpur",
  "block.minecraft.purpur_stairs": "diri purpur",
  "block.minecraft.spawner": "ganerez",
  "block.minecraft.oak_stairs": "diri derv",
  "block.minecraft.chest": "arc'h",
  "block.minecraft.diamond_ore": "kailh diamant",
  "block.minecraft.diamond_block": "bloc'h diamant",
  "block.minecraft.crafting_table": "taol aozañ",
  "block.minecraft.farmland": "douar labouret",
  "block.minecraft.furnace": "forn",
  "block.minecraft.ladder": "skeul",
  "block.minecraft.rail": "hent-houarn",
  "block.minecraft.cobblestone_stairs": "diri maen",
  "block.minecraft.lever": "loc'henn",
  "block.minecraft.stone_pressure_plate": "plakenn gwask maen",
  "block.minecraft.oak_pressure_plate": "plakenn gwask derv",
  "block.minecraft.spruce_pressure_plate": "plakenn wask pruñs",
  "block.minecraft.birch_pressure_plate": "plakenn wask bezv",
  "block.minecraft.jungle_pressure_plate": "plakenn wask koad janglenn",
  "block.minecraft.acacia_pressure_plate": "plakenn wask kasia",
  "block.minecraft.dark_oak_pressure_plate": "plakenn wask derv teñval",
  "block.minecraft.crimson_pressure_plate": "crimson pressure plate",
  "block.minecraft.warped_pressure_plate": "warped pressure plate",
  "block.minecraft.polished_blackstone_pressure_plate": "polished blackstone pressure plate",
  "block.minecraft.redstone_ore": "kailh redstone",
  "block.minecraft.redstone_torch": "etev-gouloù redstone",
  "block.minecraft.snow": "erc'h",
  "block.minecraft.ice": "skorn",
  "block.minecraft.snow_block": "bloc'h erc'h",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "pri",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "kloued derv",
  "block.minecraft.spruce_fence": "kloued pruñs",
  "block.minecraft.birch_fence": "kloued bezv",
  "block.minecraft.jungle_fence": "kloued janglenn",
  "block.minecraft.acacia_fence": "kloued kasia",
  "block.minecraft.dark_oak_fence": "kloued derv teñval",
  "block.minecraft.crimson_fence": "crimson fence",
  "block.minecraft.warped_fence": "warped fence",
  "block.minecraft.pumpkin": "sitrouilhezenn",
  "block.minecraft.carved_pumpkin": "sitrouilhezenn kizellet",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "traezh an ene",
  "block.minecraft.soul_soil": "soul soil",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polished basalt",
  "block.minecraft.soul_torch": "soul torch",
  "block.minecraft.glowstone": "maen lufrus",
  "block.minecraft.jack_o_lantern": "sitrouilhezenn-letern",
  "block.minecraft.oak_trapdoor": "dor trap derv",
  "block.minecraft.spruce_trapdoor": "trap bruñs",
  "block.minecraft.birch_trapdoor": "trap bezv",
  "block.minecraft.jungle_trapdoor": "trap koad janglenn",
  "block.minecraft.acacia_trapdoor": "trap kasia",
  "block.minecraft.dark_oak_trapdoor": "trap derv teñval",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "warped trapdoor",
  "block.minecraft.infested_stone": "roc'h gwastet",
  "block.minecraft.infested_cobblestone": "maen gwastet",
  "block.minecraft.infested_stone_bricks": "brikennoù roc'h gwastet",
  "block.minecraft.infested_mossy_stone_bricks": "brikennoù roc'h man gwastet",
  "block.minecraft.infested_cracked_stone_bricks": "brikennoù roc'h faotet gwastet",
  "block.minecraft.infested_chiseled_stone_bricks": "brikennoù roc'h sizailhet gwastet",
  "block.minecraft.stone_bricks": "brikennoù roc'h",
  "block.minecraft.mossy_stone_bricks": "brikennoù roc'h man",
  "block.minecraft.cracked_stone_bricks": "brikennoù roc'h torret",
  "block.minecraft.chiseled_stone_bricks": "brikennoù roc'h sizailhet",
  "block.minecraft.brown_mushroom_block": "bloc'h kabell-touseg gell",
  "block.minecraft.red_mushroom_block": "bloc'h kabell-touseg du",
  "block.minecraft.mushroom_stem": "troad kabell-touseg",
  "block.minecraft.iron_bars": "barrennoù houarn",
  "block.minecraft.chain": "chadenn",
  "block.minecraft.glass_pane": "gwerenn",
  "block.minecraft.melon": "sukrinenn",
  "block.minecraft.vine": "lianennoù",
  "block.minecraft.oak_fence_gate": "dorikell derv",
  "block.minecraft.spruce_fence_gate": "dorikell pruñs",
  "block.minecraft.birch_fence_gate": "dorikell bezv",
  "block.minecraft.jungle_fence_gate": "dorikell janglenn",
  "block.minecraft.acacia_fence_gate": "dorikell gwez kasia",
  "block.minecraft.dark_oak_fence_gate": "dorikell derv teñval",
  "block.minecraft.crimson_fence_gate": "crimson fence gate",
  "block.minecraft.warped_fence_gate": "warped fence gate",
  "block.minecraft.brick_stairs": "diri brikennoù",
  "block.minecraft.stone_brick_stairs": "diri brikennoù roc'h",
  "block.minecraft.mycelium": "mikeliom",
  "block.minecraft.lily_pad": "loa-zour",
  "block.minecraft.nether_bricks": "brikennoù nether",
  "block.minecraft.cracked_nether_bricks": "cracked nether bricks",
  "block.minecraft.chiseled_nether_bricks": "chiseled nether bricks",
  "block.minecraft.nether_brick_fence": "kloued brikenn nether",
  "block.minecraft.nether_brick_stairs": "diri brikenn nether",
  "block.minecraft.enchanting_table": "taol strobinellerezh",
  "block.minecraft.end_portal_frame": "steuñv dor-dal an end",
  "block.minecraft.end_stone": "roc'h an end",
  "block.minecraft.end_stone_bricks": "brikennoù roc'h an end",
  "block.minecraft.dragon_egg": "vi aerouant",
  "block.minecraft.redstone_lamp": "gouloù redstone",
  "block.minecraft.sandstone_stairs": "diri maen-traezh",
  "block.minecraft.emerald_ore": "kailh emrodez",
  "block.minecraft.ender_chest": "arc'h an end",
  "block.minecraft.tripwire_hook": "krog neudenn ziaskañ",
  "block.minecraft.emerald_block": "bloc'h emrodez",
  "block.minecraft.spruce_stairs": "diri pruñs",
  "block.minecraft.birch_stairs": "diri bezv",
  "block.minecraft.jungle_stairs": "diri koad janglenn",
  "block.minecraft.crimson_stairs": "crimson stairs",
  "block.minecraft.warped_stairs": "warped stairs",
  "block.minecraft.command_block": "bloc'h urzh",
  "block.minecraft.beacon": "balizenn",
  "block.minecraft.cobblestone_wall": "moger maen",
  "block.minecraft.mossy_cobblestone_wall": "moger maen man",
  "block.minecraft.brick_wall": "moger brikennoù",
  "block.minecraft.prismarine_wall": "moger prismarine",
  "block.minecraft.red_sandstone_wall": "moger maen-traezh ruz",
  "block.minecraft.mossy_stone_brick_wall": "moger brikennoù roc'h manek",
  "block.minecraft.granite_wall": "moger greunit",
  "block.minecraft.stone_brick_wall": "moger brikennoù roc'h",
  "block.minecraft.nether_brick_wall": "moger brikennoù nether",
  "block.minecraft.andesite_wall": "moger andezit",
  "block.minecraft.red_nether_brick_wall": "moger brikennoù ruz an nether",
  "block.minecraft.sandstone_wall": "moger maen-traezh",
  "block.minecraft.end_stone_brick_wall": "moger brikennoù roc'h an end",
  "block.minecraft.diorite_wall": "moger diorit",
  "block.minecraft.blackstone_wall": "blackstone wall",
  "block.minecraft.polished_blackstone_wall": "polished blackstone wall",
  "block.minecraft.polished_blackstone_brick_wall": "polished blackstone brick wall",
  "block.minecraft.stone_button": "bouton koad",
  "block.minecraft.oak_button": "bouton derv",
  "block.minecraft.spruce_button": "afell bruñs",
  "block.minecraft.birch_button": "bouton vezv",
  "block.minecraft.jungle_button": "bouton koad janglenn",
  "block.minecraft.acacia_button": "bouton kasia",
  "block.minecraft.dark_oak_button": "bouton derv teñval",
  "block.minecraft.crimson_button": "crimson button",
  "block.minecraft.warped_button": "warped button",
  "block.minecraft.polished_blackstone_button": "polished blackstone button",
  "block.minecraft.anvil": "annev",
  "block.minecraft.chipped_anvil": "annev boulc'het",
  "block.minecraft.damaged_anvil": "annev gwallaozet",
  "block.minecraft.trapped_chest": "arc'h trapet",
  "block.minecraft.light_weighted_pressure_plate": "plakenn gwask skañv pouezet",
  "block.minecraft.heavy_weighted_pressure_plate": "plakenn gwask pounner pouezet",
  "block.minecraft.daylight_detector": "dinoer gouloù an deiz",
  "block.minecraft.redstone_block": "bloc'h redstone",
  "block.minecraft.nether_quartz_ore": "kailh kouarz an nether",
  "block.minecraft.hopper": "founilh",
  "block.minecraft.chiseled_quartz_block": "bloc'h kouarz sizailhet",
  "block.minecraft.quartz_block": "bloc'h kouarz",
  "block.minecraft.quartz_bricks": "quartz bricks",
  "block.minecraft.quartz_pillar": "peul kouarz",
  "block.minecraft.quartz_stairs": "diri kouarz",
  "block.minecraft.activator_rail": "hent-houarn gweredekaer",
  "block.minecraft.dropper": "ingalerez",
  "block.minecraft.white_terracotta": "pri poazh gwenn",
  "block.minecraft.orange_terracotta": "pri poazh orañjez",
  "block.minecraft.magenta_terracotta": "pri poazh majenta",
  "block.minecraft.light_blue_terracotta": "pri poazh glas sklaer",
  "block.minecraft.yellow_terracotta": "pri poazh melen",
  "block.minecraft.lime_terracotta": "pri poazh gwer-melen",
  "block.minecraft.pink_terracotta": "pri poazh roz",
  "block.minecraft.gray_terracotta": "priz poazh griz",
  "block.minecraft.light_gray_terracotta": "priz poazh griz sklaer",
  "block.minecraft.cyan_terracotta": "pri poazh sian",
  "block.minecraft.purple_terracotta": "pri poazh mouk",
  "block.minecraft.blue_terracotta": "pri poazh glas",
  "block.minecraft.brown_terracotta": "pri poazh gell",
  "block.minecraft.green_terracotta": "pri poazh gwer",
  "block.minecraft.red_terracotta": "pri poazh ruz",
  "block.minecraft.black_terracotta": "pri poazh du",
  "block.minecraft.barrier": "harz",
  "block.minecraft.iron_trapdoor": "trap houarn",
  "block.minecraft.hay_block": "boutelenn blouz",
  "block.minecraft.white_carpet": "tapis gwenn",
  "block.minecraft.orange_carpet": "pallenn orañjez",
  "block.minecraft.magenta_carpet": "pallenn majenta",
  "block.minecraft.light_blue_carpet": "pallenn c'hlas sklaer",
  "block.minecraft.yellow_carpet": "pallenn melen",
  "block.minecraft.lime_carpet": "pallenn gwer-melen",
  "block.minecraft.pink_carpet": "pallenn roz",
  "block.minecraft.gray_carpet": "pallenn griz",
  "block.minecraft.light_gray_carpet": "pallenn griz sklaer",
  "block.minecraft.cyan_carpet": "pallenn sian",
  "block.minecraft.purple_carpet": "pallenn mouk",
  "block.minecraft.blue_carpet": "pallenn c'hlas",
  "block.minecraft.brown_carpet": "pallenn c'hell",
  "block.minecraft.green_carpet": "pallenn wer",
  "block.minecraft.red_carpet": "pallenn ruz",
  "block.minecraft.black_carpet": "pallenn du",
  "block.minecraft.terracotta": "pri poazh",
  "block.minecraft.coal_block": "bloc'h glaou",
  "block.minecraft.packed_ice": "pakad skorn",
  "block.minecraft.acacia_stairs": "diri kasia",
  "block.minecraft.dark_oak_stairs": "diri derv teñval",
  "block.minecraft.slime_block": "bloc'h slime",
  "block.minecraft.grass_path": "hent geot",
  "block.minecraft.sunflower": "tro-heol",
  "block.minecraft.lilac": "lireu",
  "block.minecraft.rose_bush": "bod-roz",
  "block.minecraft.peony": "pivoena",
  "block.minecraft.tall_grass": "geot hir",
  "block.minecraft.large_fern": "radenenn vras",
  "block.minecraft.white_stained_glass": "gwer tarchet gwenn",
  "block.minecraft.orange_stained_glass": "gwer tarchet orañjez",
  "block.minecraft.magenta_stained_glass": "gwer tarchet majenta",
  "block.minecraft.light_blue_stained_glass": "gwer tarchet glas sklaer",
  "block.minecraft.yellow_stained_glass": "gwer tarchet melen",
  "block.minecraft.lime_stained_glass": "gwer tarchet gwer-melen",
  "block.minecraft.pink_stained_glass": "gwer tarchet roz",
  "block.minecraft.gray_stained_glass": "gwer tarchet gris",
  "block.minecraft.light_gray_stained_glass": "gwer tarchet gris sklaer",
  "block.minecraft.cyan_stained_glass": "gwer tarchet sian",
  "block.minecraft.purple_stained_glass": "gwer tarchet mouk",
  "block.minecraft.blue_stained_glass": "gwer tarchet glas",
  "block.minecraft.brown_stained_glass": "gwer tarchet gell",
  "block.minecraft.green_stained_glass": "gwer tarchet gwer",
  "block.minecraft.red_stained_glass": "gwer tarchet ruz",
  "block.minecraft.black_stained_glass": "gwer tarchet du",
  "block.minecraft.white_stained_glass_pane": "gwerenn wenn",
  "block.minecraft.orange_stained_glass_pane": "gwerenn orañjez",
  "block.minecraft.magenta_stained_glass_pane": "gwerenn vajenta",
  "block.minecraft.light_blue_stained_glass_pane": "gwerenn glas sklaer",
  "block.minecraft.yellow_stained_glass_pane": "gwerenn velen",
  "block.minecraft.lime_stained_glass_pane": "gwerenn gwer sklaer",
  "block.minecraft.pink_stained_glass_pane": "gwerenn roz",
  "block.minecraft.gray_stained_glass_pane": "gwerenn griz",
  "block.minecraft.light_gray_stained_glass_pane": "gwerenn griz sklaer",
  "block.minecraft.cyan_stained_glass_pane": "gwerenn sian",
  "block.minecraft.purple_stained_glass_pane": "gwerenn mouk",
  "block.minecraft.blue_stained_glass_pane": "gwerenn glas",
  "block.minecraft.brown_stained_glass_pane": "gwerenn gell",
  "block.minecraft.green_stained_glass_pane": "gwerenn wer",
  "block.minecraft.red_stained_glass_pane": "gwerenn ruz",
  "block.minecraft.black_stained_glass_pane": "gwerenn zu",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "brikennoù prismarine",
  "block.minecraft.dark_prismarine": "prismarine teñval",
  "block.minecraft.prismarine_stairs": "diri prismarine",
  "block.minecraft.prismarine_brick_stairs": "diri brikenn prismarine",
  "block.minecraft.dark_prismarine_stairs": "diri prismarine teñval",
  "block.minecraft.sea_lantern": "letern mor",
  "block.minecraft.red_sandstone": "maen-traezh ruz",
  "block.minecraft.chiseled_red_sandstone": "maen-traezh ruz sizailhet",
  "block.minecraft.cut_red_sandstone": "maen-traezh ruz sizailhet",
  "block.minecraft.red_sandstone_stairs": "diri maen-traezh ruz",
  "block.minecraft.repeating_command_block": "bloc'h adurzhiañ",
  "block.minecraft.chain_command_block": "boc'h chadenn urzhiañ",
  "block.minecraft.magma_block": "bloc'h magma",
  "block.minecraft.nether_wart_block": "bloc'h gwenaenn an nether",
  "block.minecraft.warped_wart_block": "warped wart block",
  "block.minecraft.red_nether_bricks": "brikennoù ruz an nether",
  "block.minecraft.bone_block": "bloc'h eskern",
  "block.minecraft.structure_void": "goullonder frammad",
  "block.minecraft.observer": "arvester",
  "block.minecraft.shulker_box": "boest shulker",
  "block.minecraft.white_shulker_box": "boest shulker gwenn",
  "block.minecraft.orange_shulker_box": "boest shulker orañjez",
  "block.minecraft.magenta_shulker_box": "boest shulker majenta",
  "block.minecraft.light_blue_shulker_box": "boest shulker glas-sklaer",
  "block.minecraft.yellow_shulker_box": "boest shulker melen",
  "block.minecraft.lime_shulker_box": "boest shulker gwer-sklaer",
  "block.minecraft.pink_shulker_box": "boest shulker roz",
  "block.minecraft.gray_shulker_box": "boest shulker gris",
  "block.minecraft.light_gray_shulker_box": "boest shulker gris-sklaer",
  "block.minecraft.cyan_shulker_box": "boest shulker kian",
  "block.minecraft.purple_shulker_box": "boest shulker limestra",
  "block.minecraft.blue_shulker_box": "boest shulker glas",
  "block.minecraft.brown_shulker_box": "boest shulker gell",
  "block.minecraft.green_shulker_box": "boest shulker gwer",
  "block.minecraft.red_shulker_box": "boest shulker ruz",
  "block.minecraft.black_shulker_box": "boest shulker du",
  "block.minecraft.white_glazed_terracotta": "pri poazh gwerek gwenn",
  "block.minecraft.orange_glazed_terracotta": "pri poazh gwerek orañjez",
  "block.minecraft.magenta_glazed_terracotta": "pri poazh gwerek majenta",
  "block.minecraft.light_blue_glazed_terracotta": "pri poazh gwerek glas sklaer",
  "block.minecraft.yellow_glazed_terracotta": "pri poazh gwerek melen",
  "block.minecraft.lime_glazed_terracotta": "pri poazh gwerek gwer-melen",
  "block.minecraft.pink_glazed_terracotta": "pri poazh gwerek roz",
  "block.minecraft.gray_glazed_terracotta": "pri poazh gwerek griz",
  "block.minecraft.light_gray_glazed_terracotta": "pri poazh gwerek griz sklaer",
  "block.minecraft.cyan_glazed_terracotta": "pri poazh gwerek sian",
  "block.minecraft.purple_glazed_terracotta": "pri poazh gwerek mouk",
  "block.minecraft.blue_glazed_terracotta": "pri poazh gwerek glas",
  "block.minecraft.brown_glazed_terracotta": "pri poazh gwerek gel",
  "block.minecraft.green_glazed_terracotta": "pri poazh gwerek gwer",
  "block.minecraft.red_glazed_terracotta": "pri poazh gwerek ruz",
  "block.minecraft.black_glazed_terracotta": "pri poazh gwerek du",
  "block.minecraft.white_concrete": "beton gwenn",
  "block.minecraft.orange_concrete": "beton orañjez",
  "block.minecraft.magenta_concrete": "beton majenta",
  "block.minecraft.light_blue_concrete": "beton glas sklaer",
  "block.minecraft.yellow_concrete": "beton melen",
  "block.minecraft.lime_concrete": "beton gwer-melen",
  "block.minecraft.pink_concrete": "beton roz",
  "block.minecraft.gray_concrete": "beton griz",
  "block.minecraft.light_gray_concrete": "beton griz sklaer",
  "block.minecraft.cyan_concrete": "beton sian",
  "block.minecraft.purple_concrete": "beton mouk",
  "block.minecraft.blue_concrete": "beton glas",
  "block.minecraft.brown_concrete": "beton gel",
  "block.minecraft.green_concrete": "beton gwer",
  "block.minecraft.red_concrete": "beton ruz",
  "block.minecraft.black_concrete": "beton du",
  "block.minecraft.white_concrete_powder": "poultr beton gwenn",
  "block.minecraft.orange_concrete_powder": "poultr beton orañjez",
  "block.minecraft.magenta_concrete_powder": "poultr beton majenta",
  "block.minecraft.light_blue_concrete_powder": "poultr beton sian",
  "block.minecraft.yellow_concrete_powder": "poultr beton melen",
  "block.minecraft.lime_concrete_powder": "poultr beton gwer-melen",
  "block.minecraft.pink_concrete_powder": "poultr beton roz",
  "block.minecraft.gray_concrete_powder": "poultr beton griz",
  "block.minecraft.light_gray_concrete_powder": "poultr beton griz sklaer",
  "block.minecraft.cyan_concrete_powder": "poultr beton sian",
  "block.minecraft.purple_concrete_powder": "poultr beton mouk",
  "block.minecraft.blue_concrete_powder": "poultr beton glas",
  "block.minecraft.brown_concrete_powder": "poultr beton gel",
  "block.minecraft.green_concrete_powder": "poultr beton gwer",
  "block.minecraft.red_concrete_powder": "poultr beton ruz",
  "block.minecraft.black_concrete_powder": "poultr breton du",
  "block.minecraft.turtle_egg": "vi baot",
  "block.minecraft.dead_tube_coral_block": "bloc'h koural korzennek marv",
  "block.minecraft.dead_brain_coral_block": "bloc'h koural empenn marv",
  "block.minecraft.dead_bubble_coral_block": "bloc'h koural klogor marv",
  "block.minecraft.dead_fire_coral_block": "bloc'h koural tan marv",
  "block.minecraft.dead_horn_coral_block": "bloc'h koural kerniel marv",
  "block.minecraft.tube_coral_block": "bloc'h koural korzennek",
  "block.minecraft.brain_coral_block": "bloc'h koural empenn",
  "block.minecraft.bubble_coral_block": "bloc'h koural klogor",
  "block.minecraft.fire_coral_block": "bloc'h koural tan",
  "block.minecraft.horn_coral_block": "bloc'h koural kerniel",
  "block.minecraft.tube_coral": "koural korzennek",
  "block.minecraft.brain_coral": "koural empenn",
  "block.minecraft.bubble_coral": "koural klogor",
  "block.minecraft.fire_coral": "koural tan",
  "block.minecraft.horn_coral": "koural kerniel",
  "block.minecraft.dead_brain_coral": "koural empenn marv",
  "block.minecraft.dead_bubble_coral": "koural klogor marv",
  "block.minecraft.dead_fire_coral": "koural tan marv",
  "block.minecraft.dead_horn_coral": "koural kerniel marv",
  "block.minecraft.dead_tube_coral": "koural korzennek marv",
  "block.minecraft.tube_coral_fan": "aveler koural korzennek",
  "block.minecraft.brain_coral_fan": "aveler koural empenn",
  "block.minecraft.bubble_coral_fan": "aveler koural klogor",
  "block.minecraft.fire_coral_fan": "aveler koural tan",
  "block.minecraft.horn_coral_fan": "aveler koural kerniel",
  "block.minecraft.dead_tube_coral_fan": "aveler koural korzennek marv",
  "block.minecraft.dead_brain_coral_fan": "aveler koural empenn marv",
  "block.minecraft.dead_bubble_coral_fan": "aveler koural klogor marv",
  "block.minecraft.dead_fire_coral_fan": "aveler koural tan marv",
  "block.minecraft.dead_horn_coral_fan": "aveler koural kerniel marv",
  "block.minecraft.blue_ice": "skorn glas",
  "block.minecraft.conduit": "san",
  "block.minecraft.polished_granite_stairs": "diri greunit lufret",
  "block.minecraft.smooth_red_sandstone_stairs": "diri maen-traezh plaen",
  "block.minecraft.mossy_stone_brick_stairs": "diri maen-traezh manek",
  "block.minecraft.polished_diorite_stairs": "diri diorit plaen",
  "block.minecraft.mossy_cobblestone_stairs": "diri maen manek",
  "block.minecraft.end_stone_brick_stairs": "diri brikennoù roc'h an end",
  "block.minecraft.stone_stairs": "diri roc'h",
  "block.minecraft.smooth_sandstone_stairs": "diri maen-traezh plaen",
  "block.minecraft.smooth_quartz_stairs": "diri kouarz plaen",
  "block.minecraft.granite_stairs": "diri greunit",
  "block.minecraft.andesite_stairs": "diri andezit",
  "block.minecraft.red_nether_brick_stairs": "diri brikenn ruz an nether",
  "block.minecraft.polished_andesite_stairs": "diri andezit lufret",
  "block.minecraft.diorite_stairs": "diri diorit",
  "block.minecraft.polished_granite_slab": "dar greunit lufret",
  "block.minecraft.smooth_red_sandstone_slab": "dar maen-traezh ruz plaen",
  "block.minecraft.mossy_stone_brick_slab": "dar brikennoù roc'h manek",
  "block.minecraft.polished_diorite_slab": "dar diorit lufret",
  "block.minecraft.mossy_cobblestone_slab": "dar roc'h lufret",
  "block.minecraft.end_stone_brick_slab": "dar brikennoù roc'h an end",
  "block.minecraft.smooth_sandstone_slab": "dar maen-traezh plaen",
  "block.minecraft.smooth_quartz_slab": "dar kouarz plaen",
  "block.minecraft.granite_slab": "dar greunit",
  "block.minecraft.andesite_slab": "dar andezit",
  "block.minecraft.red_nether_brick_slab": "dar brikenn ruz an nether",
  "block.minecraft.polished_andesite_slab": "dar andezit lufret",
  "block.minecraft.diorite_slab": "dar diorit",
  "block.minecraft.scaffolding": "chafod",
  "block.minecraft.iron_door": "dor houarn",
  "block.minecraft.oak_door": "dor zerv",
  "block.minecraft.spruce_door": "dor bruñs",
  "block.minecraft.birch_door": "dor vezv",
  "block.minecraft.jungle_door": "dor goad janglenn",
  "block.minecraft.acacia_door": "dor gasia",
  "block.minecraft.dark_oak_door": "dor zerv teñval",
  "block.minecraft.crimson_door": "crimson door",
  "block.minecraft.warped_door": "warped door",
  "block.minecraft.repeater": "azganer redstone",
  "block.minecraft.comparator": "keñverier redstone",
  "block.minecraft.structure_block": "bloc'hoù savadur",
  "block.minecraft.jigsaw": "bloc'h mil-tamm",
  "item.minecraft.turtle_helmet": "krogenn vaot□□when on head:□+2 houarnwisk",
  "item.minecraft.scute": "skant baot",
  "item.minecraft.iron_shovel": "pal houarn□□when in main hand:□+3.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.iron_pickaxe": "pigell houarn□□when in main hand:□+3 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.iron_axe": "bouc'hal houarn□□when in main hand:□+8 freuzoù an tagadenn□-3.1 tizh tagañ",
  "item.minecraft.flint_and_steel": "kailhastr ha dir",
  "item.minecraft.apple": "aval",
  "item.minecraft.bow": "gwareg",
  "item.minecraft.arrow": "bir",
  "item.minecraft.coal": "glaou",
  "item.minecraft.charcoal": "glaou koad",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "tolzenn houarn",
  "item.minecraft.gold_ingot": "tolzenn aour",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "netherite scrap",
  "item.minecraft.iron_sword": "kleze houarn□□when in main hand:□+5 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.wooden_sword": "kleze koad□□when in main hand:□+3 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.wooden_shovel": "pal goad□□when in main hand:□+1.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.wooden_pickaxe": "pigell goad□□when in main hand:□+1 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.wooden_axe": "bouc'hal goad□□when in main hand:□+6 freuzoù an tagadenn□-3.2 tizh tagañ",
  "item.minecraft.stone_sword": "kleze maen□□when in main hand:□+4 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.stone_shovel": "pal vaen□□when in main hand:□+2.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.stone_pickaxe": "pigell vaen□□when in main hand:□+2 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.stone_axe": "bouc'hal vaen□□when in main hand:□+8 freuzoù an tagadenn□-3.2 tizh tagañ",
  "item.minecraft.diamond_sword": "kleze diamant□□when in main hand:□+6 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.diamond_shovel": "pal ziamant□□when in main hand:□+4.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.diamond_pickaxe": "pigell ziamant□□when in main hand:□+4 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.diamond_axe": "bouc'hal ziamant□□when in main hand:□+8 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.stick": "bazh",
  "item.minecraft.bowl": "bolenn",
  "item.minecraft.mushroom_stew": "soubenn tokoù-touseg",
  "item.minecraft.golden_sword": "kleze aour□□when in main hand:□+3 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.golden_shovel": "pal aour□□when in main hand:□+1.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.golden_pickaxe": "pigell aour□□when in main hand:□+1 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.golden_axe": "bouc'hal aour□□when in main hand:□+6 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.netherite_sword": "netherite sword□□when in main hand:□+7 freuzoù an tagadenn□-2.4 tizh tagañ",
  "item.minecraft.netherite_shovel": "netherite shovel□□when in main hand:□+5.5 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.netherite_pickaxe": "netherite pickaxe□□when in main hand:□+5 freuzoù an tagadenn□-2.8 tizh tagañ",
  "item.minecraft.netherite_axe": "netherite axe□□when in main hand:□+9 freuzoù an tagadenn□-3 tizh tagañ",
  "item.minecraft.string": "neudenn",
  "item.minecraft.feather": "pluenn",
  "item.minecraft.gunpowder": "poultr kanol",
  "item.minecraft.wooden_hoe": "marr goad□□when in main hand:□-3 tizh tagañ",
  "item.minecraft.stone_hoe": "marr vaen□□when in main hand:□-2 tizh tagañ",
  "item.minecraft.iron_hoe": "marr houarn□□when in main hand:□-1 tizh tagañ",
  "item.minecraft.diamond_hoe": "marr ziamant□□when in main hand:",
  "item.minecraft.golden_hoe": "marr aour□□when in main hand:□-3 tizh tagañ",
  "item.minecraft.netherite_hoe": "netherite hoe□□when in main hand:",
  "item.minecraft.wheat_seeds": "greun ed",
  "item.minecraft.wheat": "ed",
  "item.minecraft.bread": "bara",
  "item.minecraft.leather_helmet": "tok lêr□□when on head:□+1 houarnwisk",
  "item.minecraft.leather_chestplate": "sae lêr□□when on body:□+3 houarnwisk",
  "item.minecraft.leather_leggings": "bragoù lêr□□when on legs:□+2 houarnwisk",
  "item.minecraft.leather_boots": "botoù lêr□□when on feet:□+1 houarnwisk",
  "item.minecraft.chainmail_helmet": "tokarn mailhek□□when on head:□+2 houarnwisk",
  "item.minecraft.chainmail_chestplate": "sae-vailhek□□when on body:□+5 houarnwisk",
  "item.minecraft.chainmail_leggings": "bragoù mailhek□□when on legs:□+4 houarnwisk",
  "item.minecraft.chainmail_boots": "botoù mailhek□□when on feet:□+1 houarnwisk",
  "item.minecraft.iron_helmet": "tokarn houarn□□when on head:□+2 houarnwisk",
  "item.minecraft.iron_chestplate": "brennid houarn□□when on body:□+6 houarnwisk",
  "item.minecraft.iron_leggings": "bragoù houarn□□when on legs:□+5 houarnwisk",
  "item.minecraft.iron_boots": "botoù houarn□□when on feet:□+2 houarnwisk",
  "item.minecraft.diamond_helmet": "tokarn diamant□□when on head:□+3 houarnwisk□+2 kreñvder an houarnwisk",
  "item.minecraft.diamond_chestplate": "brennid diamant□□when on body:□+8 houarnwisk□+2 kreñvder an houarnwisk",
  "item.minecraft.diamond_leggings": "bragoù diamant□□when on legs:□+6 houarnwisk□+2 kreñvder an houarnwisk",
  "item.minecraft.diamond_boots": "botoù diamant□□when on feet:□+3 houarnwisk□+2 kreñvder an houarnwisk",
  "item.minecraft.golden_helmet": "tokarn aour□□when on head:□+2 houarnwisk",
  "item.minecraft.golden_chestplate": "brennid aour□□when on body:□+5 houarnwisk",
  "item.minecraft.golden_leggings": "bragoù aour□□when on legs:□+3 houarnwisk",
  "item.minecraft.golden_boots": "botoù aour□□when on feet:□+1 houarnwisk",
  "item.minecraft.netherite_helmet": "netherite helmet□□when on head:□+3 houarnwisk□+3 kreñvder an houarnwisk□+1 dalc'husted ar giladenn",
  "item.minecraft.netherite_chestplate": "netherite chestplate□□when on body:□+8 houarnwisk□+3 kreñvder an houarnwisk□+1 dalc'husted ar giladenn",
  "item.minecraft.netherite_leggings": "netherite leggings□□when on legs:□+6 houarnwisk□+3 kreñvder an houarnwisk□+1 dalc'husted ar giladenn",
  "item.minecraft.netherite_boots": "netherite boots□□when on feet:□+3 houarnwisk□+3 kreñvder an houarnwisk□+1 dalc'husted ar giladenn",
  "item.minecraft.flint": "kailhastr",
  "item.minecraft.porkchop": "kig-moc'h kriz",
  "item.minecraft.cooked_porkchop": "kig-moc'h poazh",
  "item.minecraft.painting": "livouriezh",
  "item.minecraft.golden_apple": "aval alaouret",
  "item.minecraft.enchanted_golden_apple": "aval alaouret strobinellet",
  "block.minecraft.oak_sign": "panell derv",
  "block.minecraft.spruce_sign": "panell bruñs",
  "block.minecraft.birch_sign": "panell vezv",
  "block.minecraft.jungle_sign": "panell koad janglenn",
  "block.minecraft.acacia_sign": "panell gasia",
  "block.minecraft.dark_oak_sign": "panell derv teñval",
  "block.minecraft.crimson_sign": "crimson sign",
  "block.minecraft.warped_sign": "warped sign",
  "item.minecraft.bucket": "sailh",
  "item.minecraft.water_bucket": "sailh dour",
  "item.minecraft.lava_bucket": "sailh lava",
  "item.minecraft.minecart": "bagon vengleuz",
  "item.minecraft.saddle": "dibr",
  "item.minecraft.redstone": "poultr redstone",
  "item.minecraft.snowball": "boulenn erc'h",
  "item.minecraft.oak_boat": "bag derv",
  "item.minecraft.leather": "lêr",
  "item.minecraft.milk_bucket": "sailhad laezh",
  "item.minecraft.pufferfish_bucket": "sailhad fugu",
  "item.minecraft.salmon_bucket": "sailhad eog",
  "item.minecraft.cod_bucket": "sailhad moru",
  "item.minecraft.tropical_fish_bucket": "sailhad pesk trovanel",
  "item.minecraft.brick": "brikenn",
  "item.minecraft.clay_ball": "clay ball",
  "block.minecraft.dried_kelp_block": "bloc'h bezhin sec'het",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "levr",
  "item.minecraft.slime_ball": "bolotenn slime",
  "item.minecraft.chest_minecart": "bagon vengleuz gant ur c'houfr",
  "item.minecraft.furnace_minecart": "bagon vengleuz gant ur forn",
  "item.minecraft.egg": "vi",
  "item.minecraft.compass": "nadoz-vor",
  "item.minecraft.fishing_rod": "bazh-pesketañ",
  "item.minecraft.clock": "eurier",
  "item.minecraft.glowstone_dust": "poultr lufrus",
  "item.minecraft.cod": "moru kriz",
  "item.minecraft.salmon": "eog kriz",
  "item.minecraft.tropical_fish": "pesk trovanel",
  "item.minecraft.pufferfish": "pesk-boul",
  "item.minecraft.cooked_cod": "moru poazh",
  "item.minecraft.cooked_salmon": "eog poazh",
  "item.minecraft.ink_sac": "sac'h inkr",
  "item.minecraft.red_dye": "livadur ruz",
  "item.minecraft.green_dye": "livadur gwer",
  "item.minecraft.cocoa_beans": "fav kakao",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "livadur mouk",
  "item.minecraft.cyan_dye": "livadur sian",
  "item.minecraft.light_gray_dye": "livadur griz sklaer",
  "item.minecraft.gray_dye": "livadur griz",
  "item.minecraft.pink_dye": "livadur roz",
  "item.minecraft.lime_dye": "livadur gwer-melen",
  "item.minecraft.yellow_dye": "livadur melen",
  "item.minecraft.light_blue_dye": "livadur glas sklaer",
  "item.minecraft.magenta_dye": "livadur majenta",
  "item.minecraft.orange_dye": "livadur orañjez",
  "item.minecraft.bone_meal": "poultr eskern",
  "item.minecraft.blue_dye": "livadur glas",
  "item.minecraft.brown_dye": "livadur gell",
  "item.minecraft.black_dye": "livadur du",
  "item.minecraft.white_dye": "livadur gwenn",
  "item.minecraft.bone": "askorn",
  "item.minecraft.sugar": "sukr",
  "block.minecraft.cake": "gwastell",
  "block.minecraft.white_bed": "gwele gwenn",
  "block.minecraft.orange_bed": "gwele orañjez",
  "block.minecraft.magenta_bed": "gwele majenta",
  "block.minecraft.light_blue_bed": "gwele glas sklaer",
  "block.minecraft.yellow_bed": "gwelen melen",
  "block.minecraft.lime_bed": "gwele gwer-melen",
  "block.minecraft.pink_bed": "gwele roz",
  "block.minecraft.gray_bed": "gwele griz",
  "block.minecraft.light_gray_bed": "gwele griz sklaer",
  "block.minecraft.cyan_bed": "gwele sian",
  "block.minecraft.purple_bed": "gwele mouk",
  "block.minecraft.blue_bed": "gwele glas",
  "block.minecraft.brown_bed": "gwele gell",
  "block.minecraft.green_bed": "gwele gwer",
  "block.minecraft.red_bed": "gwele ruz",
  "block.minecraft.black_bed": "gwele du",
  "item.minecraft.cookie": "gwispidenn",
  "item.minecraft.filled_map": "kartenn□#0",
  "item.minecraft.shears": "gweltre",
  "item.minecraft.melon_slice": "lodenn sukrinenn",
  "item.minecraft.dried_kelp": "bezhin sec'het",
  "item.minecraft.pumpkin_seeds": "greun sitrouilhez",
  "item.minecraft.melon_seeds": "greun sukrin",
  "item.minecraft.beef": "kig-bevin kriz",
  "item.minecraft.cooked_beef": "kig-bevin poazh",
  "item.minecraft.chicken": "kig-yar kriz",
  "item.minecraft.cooked_chicken": "kig-yar poazh",
  "item.minecraft.rotten_flesh": "kig brein",
  "item.minecraft.ender_pearl": "perlezenn an end",
  "item.minecraft.blaze_rod": "bazh tan",
  "item.minecraft.ghast_tear": "daerenn ghast",
  "item.minecraft.gold_nugget": "malzenn aour",
  "item.minecraft.nether_wart": "gwenaenn nether",
  "item.minecraft.potion": "braou n'haller ket aozañ□efed ebet",
  "item.minecraft.glass_bottle": "boutailh wer",
  "item.minecraft.spider_eye": "lagad kevnidenn",
  "item.minecraft.fermented_spider_eye": "lagad kevnidenn c'hoellet",
  "item.minecraft.blaze_powder": "poultr tan",
  "item.minecraft.magma_cream": "dienn vagma",
  "block.minecraft.brewing_stand": "lambig",
  "block.minecraft.cauldron": "kaoter",
  "item.minecraft.ender_eye": "lagad an end",
  "item.minecraft.glistering_melon_slice": "lodenn sukrinenn lufrus",
  "item.minecraft.bat_spawn_egg": "vi ganerez eskell-groc'hen",
  "item.minecraft.bee_spawn_egg": "vi ganerez gwenan",
  "item.minecraft.blaze_spawn_egg": "vi ganerez blaze",
  "item.minecraft.cat_spawn_egg": "vi ganerez kizhier",
  "item.minecraft.cave_spider_spawn_egg": "vi ganerez kevnid mougev",
  "item.minecraft.chicken_spawn_egg": "vi ganerez yer",
  "item.minecraft.cod_spawn_egg": "vi ganerez moru",
  "item.minecraft.cow_spawn_egg": "vi ganerez saout",
  "item.minecraft.creeper_spawn_egg": "vi ganerez creeper",
  "item.minecraft.dolphin_spawn_egg": "vi ganerez delfined",
  "item.minecraft.donkey_spawn_egg": "vi ganerez azened",
  "item.minecraft.drowned_spawn_egg": "vi ganerez beuzeded",
  "item.minecraft.elder_guardian_spawn_egg": "vi ganerez gwarded meur",
  "item.minecraft.enderman_spawn_egg": "vi ganerez endermen",
  "item.minecraft.endermite_spawn_egg": "vi ganerez endermites",
  "item.minecraft.evoker_spawn_egg": "vi ganerez dec'halver",
  "item.minecraft.fox_spawn_egg": "vi ganerez louarn",
  "item.minecraft.ghast_spawn_egg": "vi ganerez ghasts",
  "item.minecraft.guardian_spawn_egg": "vi ganerez gwarded",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn egg",
  "item.minecraft.horse_spawn_egg": "vi ganerez kezeg",
  "item.minecraft.husk_spawn_egg": "vi ganerez disec'haned",
  "item.minecraft.llama_spawn_egg": "vi ganerez lama",
  "item.minecraft.magma_cube_spawn_egg": "vi ganerezh kuboù magma",
  "item.minecraft.mooshroom_spawn_egg": "vi ganerez mooshrooms",
  "item.minecraft.mule_spawn_egg": "vi ganerez muletez",
  "item.minecraft.ocelot_spawn_egg": "vi ganerez oselo",
  "item.minecraft.panda_spawn_egg": "vi ganerez panda",
  "item.minecraft.parrot_spawn_egg": "vi ganerez peroked",
  "item.minecraft.phantom_spawn_egg": "vi ganerez tasmantoù",
  "item.minecraft.pig_spawn_egg": "vi ganerez moc'h",
  "item.minecraft.piglin_spawn_egg": "piglin spawn egg",
  "item.minecraft.pillager_spawn_egg": "vi gannerez preizhataer",
  "item.minecraft.polar_bear_spawn_egg": "vi ganerez arzhed gwenn",
  "item.minecraft.pufferfish_spawn_egg": "vi ganerez pesked-boul",
  "item.minecraft.rabbit_spawn_egg": "vi ganerezh konikled",
  "item.minecraft.ravager_spawn_egg": "vi ganerez draster",
  "item.minecraft.salmon_spawn_egg": "vi ganerez eoged",
  "item.minecraft.sheep_spawn_egg": "vi ganerez deñved",
  "item.minecraft.shulker_spawn_egg": "vi ganerez shulker",
  "item.minecraft.silverfish_spawn_egg": "vi ganerez pesked-arc'hant",
  "item.minecraft.skeleton_spawn_egg": "vi ganerez skeled",
  "item.minecraft.skeleton_horse_spawn_egg": "vi ganerez kezeg skeledenn",
  "item.minecraft.slime_spawn_egg": "vi ganerez slime",
  "item.minecraft.spider_spawn_egg": "vi ganerez kevnid",
  "item.minecraft.squid_spawn_egg": "vi ganerez stioganed",
  "item.minecraft.stray_spawn_egg": "vi ganerez kantreerien",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "vi ganerez lama marc'hadour",
  "item.minecraft.tropical_fish_spawn_egg": "vi ganerez pesked trovanel",
  "item.minecraft.turtle_spawn_egg": "vi ganerez baoted",
  "item.minecraft.vex_spawn_egg": "vi ganerez vex",
  "item.minecraft.villager_spawn_egg": "vi ganerez kêriadennerien",
  "item.minecraft.vindicator_spawn_egg": "vi ganerez gourvenner",
  "item.minecraft.wandering_trader_spawn_egg": "vi ganerez marc'hadour kantreer",
  "item.minecraft.witch_spawn_egg": "vi ganerez sorserezed",
  "item.minecraft.wither_skeleton_spawn_egg": "vi ganerez skeledenn wither",
  "item.minecraft.wolf_spawn_egg": "vi ganerez bleizi",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.zombie_spawn_egg": "vi ganerez zombi",
  "item.minecraft.zombie_horse_spawn_egg": "vi ganerez kezeg zombi",
  "item.minecraft.zombie_villager_spawn_egg": "vi ganerez kêriadennerien zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "zombified piglin spawn egg",
  "item.minecraft.experience_bottle": "braoued strobinellerezh",
  "item.minecraft.fire_charge": "karg tan",
  "item.minecraft.writable_book": "levr ha pluenn",
  "item.minecraft.written_book": "levr skrivet",
  "item.minecraft.emerald": "emrodez",
  "item.minecraft.item_frame": "framm an objed",
  "block.minecraft.flower_pot": "pod bleunioù",
  "item.minecraft.carrot": "karotezenn",
  "item.minecraft.potato": "aval-douar",
  "item.minecraft.baked_potato": "aval-douar poazh",
  "item.minecraft.poisonous_potato": "aval-douar ampoezonet",
  "item.minecraft.map": "kartenn c'houlo",
  "item.minecraft.golden_carrot": "karotezenn alaouret",
  "block.minecraft.skeleton_skull": "klopenn skeledenn",
  "block.minecraft.wither_skeleton_skull": "klopenn skeledenn wither",
  "block.minecraft.player_head": "penn c'hoarier",
  "block.minecraft.zombie_head": "penn zombi",
  "block.minecraft.creeper_head": "penn creeper",
  "block.minecraft.dragon_head": "penn aerouant",
  "item.minecraft.carrot_on_a_stick": "karotezenn war ur vazh",
  "item.minecraft.warped_fungus_on_a_stick": "warped fungus on a stick",
  "item.minecraft.nether_star": "steredenn nether",
  "item.minecraft.pumpkin_pie": "tartezenn sitrouilhez",
  "item.minecraft.firework_rocket": "fuc'hell tan-arvest",
  "item.minecraft.firework_star": "steredenn tan-arvest",
  "item.minecraft.enchanted_book": "levr strobinellet",
  "item.minecraft.nether_brick": "brikenn nether",
  "item.minecraft.quartz": "kouarz an nether",
  "item.minecraft.tnt_minecart": "bagon vengleuz gant tnt",
  "item.minecraft.hopper_minecart": "bagon vengleuz gant ur founilh",
  "item.minecraft.prismarine_shard": "lufr prismarine",
  "item.minecraft.prismarine_crystals": "strink prismarine",
  "item.minecraft.rabbit": "kig-lapin kriz",
  "item.minecraft.cooked_rabbit": "kig-konikl poazh",
  "item.minecraft.rabbit_stew": "ragoud konikl",
  "item.minecraft.rabbit_foot": "pav konikl",
  "item.minecraft.rabbit_hide": "kroc'hen konikl",
  "item.minecraft.armor_stand": "douger houarnwisk",
  "item.minecraft.iron_horse_armor": "houarnwisk marc'h",
  "item.minecraft.golden_horse_armor": "dilhad marc'h alaouret",
  "item.minecraft.diamond_horse_armor": "dilhad diamant marc'h",
  "item.minecraft.leather_horse_armor": "dilhad lêr marc'h",
  "item.minecraft.lead": "lêrenn",
  "item.minecraft.name_tag": "tikedenn anv",
  "item.minecraft.command_block_minecart": "bagon vengleuz gant ur bloc'h urzh",
  "item.minecraft.mutton": "kig-dañvad kriz",
  "item.minecraft.cooked_mutton": "kig-dañvad poazh",
  "block.minecraft.white_banner": "banniel gwenn",
  "block.minecraft.orange_banner": "banniel orañjez",
  "block.minecraft.magenta_banner": "banniel majenta",
  "block.minecraft.light_blue_banner": "banniel glas sklaer",
  "block.minecraft.yellow_banner": "banniel melen",
  "block.minecraft.lime_banner": "banniel gwer-melen",
  "block.minecraft.pink_banner": "banniel roz",
  "block.minecraft.gray_banner": "banniel griz",
  "block.minecraft.light_gray_banner": "banniel griz sklaer",
  "block.minecraft.cyan_banner": "banniel sian",
  "block.minecraft.purple_banner": "banniel mouk",
  "block.minecraft.blue_banner": "banniel glas",
  "block.minecraft.brown_banner": "banniel gell",
  "block.minecraft.green_banner": "banniel gwer",
  "block.minecraft.red_banner": "banniel ruz",
  "block.minecraft.black_banner": "banniel du",
  "item.minecraft.end_crystal": "strink an end",
  "item.minecraft.chorus_fruit": "frouezhenn gorus",
  "item.minecraft.popped_chorus_fruit": "frouezhenn gorus straket",
  "item.minecraft.beetroot": "beterabez",
  "item.minecraft.beetroot_seeds": "greun beterabez",
  "item.minecraft.beetroot_soup": "soubenn veterabez",
  "item.minecraft.dragon_breath": "c'hwezh an aerouant",
  "item.minecraft.splash_potion": "braou taoladus n'haller ket aozañ□efed ebet",
  "item.minecraft.spectral_arrow": "bir tasmantek",
  "item.minecraft.tipped_arrow": "dibosupl d'ober ar bir gant efedoù□efed ebet",
  "item.minecraft.lingering_potion": "braou padus n'haller ket aozañ□efed ebet",
  "item.minecraft.shield": "skoed",
  "item.minecraft.elytra": "adeskell",
  "item.minecraft.spruce_boat": "bag pruñs",
  "item.minecraft.birch_boat": "bag bezv",
  "item.minecraft.jungle_boat": "bag janglenn",
  "item.minecraft.acacia_boat": "bag kasia",
  "item.minecraft.dark_oak_boat": "bag derv teñval",
  "item.minecraft.totem_of_undying": "totem an divarvelezh",
  "item.minecraft.shulker_shell": "krogen shulker",
  "item.minecraft.iron_nugget": "malzenn houarn",
  "item.minecraft.knowledge_book": "levr ar ouiziegezh",
  "item.minecraft.debug_stick": "bazh diveugañ",
  "item.minecraft.music_disc_13": "pladenn sonerezh□c418 - 13",
  "item.minecraft.music_disc_cat": "pladenn sonerezh□c418 - cat",
  "item.minecraft.music_disc_blocks": "pladenn sonerezh□c418 - blocks",
  "item.minecraft.music_disc_chirp": "pladenn sonerezh□c418 - chirp",
  "item.minecraft.music_disc_far": "pladenn sonerezh□c418 - far",
  "item.minecraft.music_disc_mall": "pladenn sonerezh□c418 - mall",
  "item.minecraft.music_disc_mellohi": "pladenn sonerezh□c418 - mellohi",
  "item.minecraft.music_disc_stal": "pladenn sonerezh□c418 - stal",
  "item.minecraft.music_disc_strad": "pladenn sonerezh□c418 - strad",
  "item.minecraft.music_disc_ward": "pladenn sonerezh□c418 - ward",
  "item.minecraft.music_disc_11": "pladenn sonerezh□c418 - 11",
  "item.minecraft.music_disc_wait": "pladenn sonerezh□c418 - wait",
  "item.minecraft.music_disc_pigstep": "pladenn sonerezh□lena raine - pigstep",
  "item.minecraft.trident": "tridant□□when in main hand:□+8 freuzoù an tagadenn□-2.9 tizh tagañ",
  "item.minecraft.phantom_membrane": "ezel tasmant",
  "item.minecraft.nautilus_shell": "krogenn naotil",
  "item.minecraft.heart_of_the_sea": "kalon ar mor",
  "item.minecraft.crossbow": "kroazwareg",
  "item.minecraft.suspicious_stew": "ragoud touellus",
  "block.minecraft.loom": "stern-gwiader",
  "item.minecraft.flower_banner_pattern": "patrom banniel□penn bleunienn",
  "item.minecraft.creeper_banner_pattern": "patrom banniel□penn creeper",
  "item.minecraft.skull_banner_pattern": "patrom banniel□penn klopenn",
  "item.minecraft.mojang_banner_pattern": "patrom banniel□arouez",
  "item.minecraft.globe_banner_pattern": "patrom banniel□boul",
  "item.minecraft.piglin_banner_pattern": "patrom banniel□snout",
  "block.minecraft.composter": "rotel",
  "block.minecraft.barrel": "tonell",
  "block.minecraft.smoker": "mogeder",
  "block.minecraft.blast_furnace": "uhelforn",
  "block.minecraft.cartography_table": "taol kartennouriezh",
  "block.minecraft.fletching_table": "taol gwaregañ",
  "block.minecraft.grindstone": "breolimerez",
  "block.minecraft.lectern": "letrinad",
  "block.minecraft.smithing_table": "taol goveliañ",
  "block.minecraft.stonecutter": "kizellerez",
  "block.minecraft.bell": "kloc'h",
  "block.minecraft.lantern": "letern",
  "block.minecraft.soul_lantern": "soul lantern",
  "item.minecraft.sweet_berries": "skav sukret",
  "block.minecraft.campfire": "tan kamp",
  "block.minecraft.soul_campfire": "soul campfire",
  "block.minecraft.shroomlight": "shroomlight",
  "item.minecraft.honeycomb": "neizh gwenan",
  "block.minecraft.bee_nest": "ruskenn",
  "block.minecraft.beehive": "koloenn",
  "item.minecraft.honey_bottle": "bouteillad mell",
  "block.minecraft.honey_block": "blokad mell",
  "block.minecraft.honeycomb_block": "blokad mell",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "block of netherite",
  "block.minecraft.ancient_debris": "ancient debris",
  "block.minecraft.target": "target",
  "block.minecraft.crying_obsidian": "crying obsidian",
  "block.minecraft.blackstone": "blackstone",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "blackstone stairs",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "polished blackstone",
  "block.minecraft.polished_blackstone_slab": "polished blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "polished blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "polished blackstone bricks",
  "block.minecraft.polished_blackstone_brick_slab": "polished blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "polished blackstone brick stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked polished blackstone bricks",
  "block.minecraft.respawn_anchor": "respawn anchor",
}
export const br_fr = items; 
